import { Divider, Flex } from "antd";

import { KSemiText700, Loading } from "@components";
import { useFetchInfoTypesService } from "@hooks";
import { useListInfoType } from "@store";
import { EFileSort } from "@types";
import { useMemo, useState } from "react";
import { ProcedureItem, SortItem } from "../item";
import { getQuery } from "@utils/card";

export const ListProcedure = () => {
  const {
    pastProcedureList = [],
    upcomingProcedureList = [],
    isLoadingList,
    isLoadingInactiveList,
  } = useListInfoType();
  const [sort, setSort] = useState<EFileSort>(EFileSort.New);

  const query = useMemo(() => getQuery(sort), [sort]);

  useFetchInfoTypesService("Procedures", query);

  return (
    <Flex gap={8} vertical={true}>
      <KSemiText700>Upcoming Procedures</KSemiText700>
      <SortItem sort={sort} setSort={setSort} />
      {isLoadingList ? (
        <Loading />
      ) : (
        upcomingProcedureList.map((item) => (
          <ProcedureItem key={item._id} card={item} />
        ))
      )}
      <Divider />
      <KSemiText700>Past Procedures</KSemiText700>
      {isLoadingInactiveList ? (
        <Loading />
      ) : (
        pastProcedureList.map((item) => (
          <ProcedureItem key={item._id} card={item} />
        ))
      )}
    </Flex>
  );
};
